<template>
  <div>
    <v-data-table
      :items="items"
      :headers="processedHeaders"
      :hide-default-footer="true"
      :hide-default-header="$vuetify.breakpoint.name!='xs'"
      :items-per-page="por_pagina"
      :item-key="itemKey"
      class="elevation-5"
    >
    <template
      v-slot:header="{ props, on }"
      #header
      v-if="$vuetify.breakpoint.name != 'xs'"
    >
      <thead>
        <tr>
          <th
            v-for="h in props.headers"
            :key="h.value"
            :style="{'padding-block': '2em', width: h.width, cursor: h.sortable !== false ? 'pointer' : 'default' }"
            @click="h.sortable !== false && on.sort(h.value)"
          >
              <div
              :class="getHeaderAlignClass(h)"
              :style="{ display: 'flex', alignItems: 'center', justifyContent: getHeaderJustify(h) }"
            >
              <p style="font-size: 1.15em; color: black; font-weight: bold; margin:0;">
                {{ h.text }}
              </p>
              <v-icon v-if="h.sortable !== false" small class="ml-1">
                {{
                  props.options.sortBy.includes(h.value)
                    ? props.options.sortDesc[0] ? 'mdi-arrow-down' : 'mdi-arrow-up'
                    : 'mdi-swap-vertical'
                }}
              </v-icon>
            </div>
          </th>
        </tr>
      </thead>
    </template>

    <template v-for="v in slotsColumn" #[`item.${v}`]="{item, index}">
      <slot :name="v" :item="item" :index="index"/>
    </template>
    </v-data-table>

    <div class="mt-4">
      <app-pagination
        v-model="numPage"
        :total-pages="total"
        :per-page="por_pagina"
        @change="changePagina"
        @perPageChange="changePerPage"
      ></app-pagination>
    </div>
  </div>
</template>


<style scope>

/*tbody tr:nth-child(even) {
  background-color: #fff !important;
}

tbody tr:nth-child(odd) {
  background-color: #e3eff1 !important;
}*/

</style>

<script>
// import AppPagination from "@/components/AppPagination.vue";
import { mapState } from "vuex/dist/vuex.common.js";
import AppPagination from "./ComponentPaginationProcess.vue"

export default {
  components: {AppPagination},
  props: {
    items: {
      type: Array,
      default: () => ([])
    },
    headers: {
      type: Array,
      default: () => ([])
    },
    headerSlot: {
      type: String,
      default: ""
    },
    slotsColumn: {
      type: Array,
      default: () => ([])
    },
    por_pagina: {
      type: Number,
      default: 5
    },
    page: {
      type: Number,
      default: 1
    },
    totalRegistros: {
      type: Number,
      default: 0
    },
    itemKey: {
      type: String,
      default: 'id'
    },
  },
  data() {
    return {
      numPage: 0
    }
  },
  methods: {
    // changePaginarion(page) {
    //   this.$emit('change', page)
    // }
    changePagina(nuevo, old) {
      this.$emit("paginationChange", nuevo);
    },
    changePerPage(porPagina) {
      this.$emit("cambioPorPagina", porPagina);
    },
    getHeaderAlignClass(header) {
      const headerAlign = header['header-align'] || 'center'
      if (headerAlign === 'start') return 'text-left'
      if (headerAlign === 'end') return 'text-right'
      return 'text-center'
    },
    getHeaderJustify(header) {
      const headerAlign = header['header-align'] || 'center'
      if (headerAlign === 'start') return 'flex-start'
      if (headerAlign === 'end') return 'flex-end'
      return 'center'
    }
  },
  computed: {
    ...mapState("solicitud", ["listadoPersonasDesdeBackend"]),
    total() {
      if(!this.listadoPersonasDesdeBackend){
        return Math.ceil(this.totalRegistros / this.por_pagina)
      }
      const paginas = this.totalRegistros;
      return paginas;
    },
    processedHeaders() {
      return this.headers.map(header => {
        const headerAlign = header['header-align'] || 'center'
        return {
          ...header,
          class: `header-align-${headerAlign}`
        }
      })
    }
  },
  watch: {
    items: function (nuevo, anterior) {
      if(nuevo.length === 0 && this.numPage !== 1){
        this.numPage= 1
      }
    },
  },
  created() {
    this.numPage = this.page
  }
}
</script>
<style>
tbody tr:nth-of-type(odd) {
  background-color: #eeeeee
}

/* Alineamiento dinámico de headers */
thead tr th.header-align-center {
  text-align: center !important;
}

thead tr th.header-align-start {
  text-align: start !important;
}

thead tr th.header-align-end {
  text-align: end !important;
}
</style>
